import { activateOrderBatchRequest, activateCashOrderRequest } from './api';

export default {
  async activateOrderBatch({ rootState }, { uniqueOrderNumber }) {
    try {
      const response = await activateOrderBatchRequest({
        session: rootState.session,
        uniqueOrderNumber: uniqueOrderNumber,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
  async activeCashOrder({ rootState }, { order, selectedPaymentType }) {
    try {
      const session = rootState.session;
      const response = await activateCashOrderRequest({
        session,
        order,
        selectedPaymentType,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
};
